'use client';

import { createRoot } from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import './styles/tokens.css';
import './styles/index.css';
// Ant Design's baseline reset. Imported after index.css so its element-level
// rules keep winning by source order, exactly as when it lived in App.css.
import 'antd/dist/reset.css';
import App from './containers/App';
import { queryClient } from './queries/queryClient';
import { createAppRouter } from './routes/createAppRouter';

const router = createAppRouter(queryClient);

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Root element not found');
const root = createRoot(rootElement);
root.render(
  <QueryClientProvider client={queryClient}>
    <App router={router} />
    {import.meta.env.DEV && <ReactQueryDevtools initialIsOpen={false} />}
  </QueryClientProvider>,
);
